<template>
  <a-layout-header
    class="header"
  >
    <!-- <div
      class="header__logo"
      :style="{'backgroundImage': `url(${logo})`}"
      @click="handleClickLogo"
    /> -->
    <!-- <div
      class="d-flex"
      style="margin-left: 80px"
    >
      <div
        v-for="route in routesConfig"
        :key="route.path"
        class="menu-item"
        :class="{'active': route.path === selectedMenuPath}"
        @click="updateMenu(route.path)"
      >
        <BizIcon
          v-if="route.icon"
          :type="route.icon"
          style="margin-right: 5px"
        />
        {{ route.name }}
      </div>
    </div> -->
    <div class="header__user">
      <div style="color: var(--text-color-o-65); margin-right: 12px">{{ (userInfo ||{}).merchant_full_name }}</div>
      <!-- <a-divider type="vertical" />
      <a-select
        :value="(activeProduct||{}).activeRule"
        style="width: 140px; margin-right: 20px; margin-left: 20px"
        @change="changeProduct"
      >
        <a-select-option
          v-for="product in productAppList"
          :key="product.activeRule"
          :value="product.activeRule"
        >{{ product.meta.title }}</a-select-option>
      </a-select> -->
      <!-- <div class="header__theme-switch">
        <a-switch
          :checked="theme === THEMES.DARK"
          @change="switchTheme"
        />
        <div style="color: var(--text-color-o-65)">切换{{ theme === THEMES.DARK ? '浅色' : '深色' }}</div>
      </div> -->
      <a-divider type="vertical" />
      <!-- 通知（目前接入的是小程序后台通知） -->
      <Notify @pwdShow="showEditPwdModal = true"/>
      <a-divider type="vertical" />
      <a-dropdown
        :visble="showDropDown"
        @visibleChange="visibleChange"
      >
        <div :class="showDropDown ? 'header__user__config header__user__config__active' : 'header__user__config'">
          <BizIcon
            class="header__user__icon"
            type="iconhebingxingzhuang"
            style="margin-left: 8px"
          />
          <span
            class="header__user__name"
            style="margin-left: 8px;color: var(--text-color-o-65);"
          >
            {{ (userInfo||{}).real_name }}
          </span>
        </div>
        <a-menu
          slot="overlay"
          class="header__user__menu"
        >
          <a-menu-item
            v-if="userInfo && userInfo.isAdmin"
            class="header__user__menu__item"
            @click="$router.push('/main/account')"
          >账号管理</a-menu-item>
          <a-menu-item
            v-if="userInfo && userInfo.isAdmin"
            class="header__user__menu__item"
            @click="$router.push('/main/role')"
          >角色管理</a-menu-item>
          <!-- <a-menu-item
            class="header__user__menu__item"
            @click="$router.push('/main/store')"
          >门店组</a-menu-item> -->
          <!-- <a-menu-item
            v-if="activeProduct && activeProduct.name === 'mvp'"
            class="header__user__menu__item"
            @click="$router.push('/mvp/insight/monitor')"
          >监控设置</a-menu-item> -->
          <a-menu-item
            class="header__user__menu__item"
            @click="showEditPwdModal = true"
          >修改密码</a-menu-item>
          <a-menu-item
            class="header__user__menu__item header__user__menu__item--logout"
            @click="handleLogout"
          >退出登录</a-menu-item>
        </a-menu>
      </a-dropdown>
      <template v-if="contractInfo.expireTime">
        <a-divider type="vertical" />
        <div class="contract">
          <div class="contract-state">{{ contractStateText }}</div>
          <div class="contract-date">到期时间：{{ contractInfo.expireTime }}</div>
        </div>
      </template>
    </div>
    <aside>
      <EditPwdDrawer
        v-if="showEditPwdModal"
        :visible="showEditPwdModal"
        @ok="handleEditPwd"
        @cancel="handleEditPwdCancel"
      />
    </aside>
  </a-layout-header>
</template>

<script>
import { initGlobalState } from 'qiankun';
import { mapState } from 'vuex';
import {
  THEMES,
} from '@/consts';
import BizIcon from '@/components/BizIcon';
import { getAppByPath } from '@/micro-apps';
import { goToFirstValidRoute } from '@/utils/helpers';
import EditPwdDrawer from './edit-pwd-drawer';
import Notify from './notify';

const initialState = {
  theme: localStorage.getItem('theme') || THEMES.LIGHT,
};
const actions = initGlobalState(initialState);


export default {
  components: {
    BizIcon,
    EditPwdDrawer,
    Notify,
  },
  computed: {
    ...mapState('user', ['userInfo', 'isChangePassword']),
    ...mapState(['contractInfo']),
    contractStateText() {
      // ON: 续约中，OFF 已结束(过期)，FREEZE: 暂停(终止)
      const state = {
        ON: '续约中',
        OFF: '已过期',
        FREEZE: '已终止',
      };
      const { contractState } = this.contractInfo;
      return state[contractState];
    },
  },
  watch: {
    isChangePassword: {
      handler(newVal) {
        if (newVal) {
          this.showEditPwdModal = true;
          this.$store.commit('user/updateChangePwd', false);
        }
      },
      immediate: true,
    },
  },
  props: {
    routesConfig: {
      type: Array,
      default() {
        return [];
      },
    },
    selectedMenuPath: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      showEditPwdModal: false,
      showDropDown: false,
      theme: initialState.theme,
      THEMES,
      logo: process.env.LOGO,
    };
  },
  methods: {
    visibleChange(v) {
      this.showDropDown = v;
    },
    switchTheme(val) {
      this.theme = val ? THEMES.DARK : THEMES.LIGHT;

      const darkLink = document.querySelector('link[title=main-dark]');
      const lightLink = document.querySelector('link[title=main-light]');
      
      darkLink.disabled = true;
      darkLink.disabled = this.theme !== THEMES.DARK;
      lightLink.disabled = true;
      lightLink.disabled = this.theme !== THEMES.LIGHT;

      localStorage.setItem('theme', this.theme);

      // 将主题切换消息分发给子应用
      actions.setGlobalState({
        theme: this.theme,
      });
    },
    changeProduct(value) {
      this.$router.push(value);
      this.activeProduct = getAppByPath(value);
    },
    handleClickLogo() {
      goToFirstValidRoute(this.$router);
    },
    handleLogout() {
      this.$store.dispatch('user/logout');
    },
    handleEditPwd(payload) {
      this.$store.dispatch('user/editPwd', payload)
        .then(() => {
          this.$message.success('修改成功');
          this.showEditPwdModal = false;
          this.handleLogout();
        });
    },
    handleEditPwdCancel() {
      this.showEditPwdModal = false;
    },
    updateMenu(path) {
      // header大菜单
      this.$emit('update:selected-menu-path', path);

      // 修改header大菜单后显示该大菜单下的第一个路由
      goToFirstValidRoute(this.$router, path);
    },
  },
};
</script>

<style lang="less" scoped>
.header {
  cursor: default;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-left: 252px;
  top: 0;
  width: calc(100% - 252px);
  height: 64px;
  padding: 0 40px;
  font-size: 16px;
  line-height: 64px;
  background-color: var(--navi-bg);
  border-bottom: 1px solid #E8E8E8;
  // box-shadow: 0 2px 6px 0px rgba(0, 0, 0, .08);
  z-index: 1;
  &__logo {
    float: left;
    height: 19px;
    width: 107px;
    line-height: 64px;
    color: white;
    cursor: pointer;
    background-size: 100% 100%;
  }

  &__menu {
    display: block;
    flex-grow: 1;
    margin-left: 53px;
    font-size: 0;

    &__item {
      display: inline-block;
      margin: 0 24px;
      font-size: 14px;
      color: rgba(255, 255, 255, .45);
      border-bottom: 2px solid transparent;

      &:hover {
        color: var(--main-color);
      }

      ::v-deep &.router-link-active {
        color: var(--main-color);
        border-bottom-color: var(--main-color);
      }
    }
  }

  &__theme-switch {
    width: 140px;
    height: 32px;
    padding: 0 14px;
    border-radius: 2px;
    border: 1px solid var(--border-color-base);
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-right: 10px;

    .antmain-switch::after {
      background: white !important;
    }
  }

  &__user {
    flex: 1;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    &__config {
      &__active {
        color: #3BAEBC;
        > span {
          color:#3BAEBC;
        }
      }
      &:hover {
        color: #3BAEBC;
        > span {
          color:#3BAEBC;
        }
      }
    }
    &__name {
      color: rgba(255,255,255,.65);
    }
    &__icon {
      position: relative;
      top: -2px;
      vertical-align: middle;
      font-size: 20px;
      color: var(--text-color-o-65);
    }

    &__menu {
      border-radius: 6px;
      background-color: var(--dropdown-bg);
      color: white;
      box-shadow: 0px 9px 28px 8px rgba(0,0,0,0.2),0px 6px 16px 0px rgba(0,0,0,0.32),0px 3px 6px -4px rgba(0,0,0,0.48);

      &__item {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 8px 16px;
        background-color: transparent !important;
        color: var(--text-color-o-65) !important;

        &:hover {
          background-color: var(--main-color) !important;
          color: #FFF !important;
        }

        &--logout {
          color: #3BAEBC !important;
        }
      }
    }
  }
}
.menu-item {
  margin-right: 56px;
  cursor: pointer;

  &.active {
    color: var(--main-color)
  }
}
.contract {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1;
  margin-left: 20px;
}
.contract-state {
  font-size: 14px;
  margin-bottom: 4px;
  color: var(--main-color);
}
.contract-date {
  font-size: 12px;
}
</style>
